"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.testResults.title': 'Resultados de prueba',
    'botTest.testResults.results': 'resultados',
    'botTest.testResults.result': 'Resultado',
    'botTest.testResults.metrics': 'Métricas',
    'botTest.testResults.totalMessages': 'Total de mensajes',
    'botTest.testResults.totalTokens': 'Total de tokens',
    'botTest.testResults.totalCost': 'Coste total',
    'botTest.testResults.executionTime': 'Tiempo de ejecución',
    'botTest.testResults.averageResponseTime': 'Tiempo promedio de finalización de pregunta',
    'botTest.testResults.inputTokens': 'Tokens de entrada',
    'botTest.testResults.outputTokens': 'Tokens de salida',
    'botTest.testResults.messageCount': 'Mensajes',
    'botTest.testResults.error': 'Error',
    'botTest.testResults.response': 'Respuesta de IA',
    'botTest.testResults.questionGeneration': 'Generación de preguntas',
    'botTest.testResults.success': 'Éxito',
    'botTest.testResults.tokens': 'Tokens',
    'botTest.testResults.cost': 'Coste',
    'botTest.testResults.status.pending': 'Pendiente',
    'botTest.testResults.status.running': 'En curso',
    'botTest.testResults.status.completed': 'Completado',
    'botTest.testResults.status.failed': 'Fallido',
    'botTest.testResults.questionsAndAnswers': 'Preguntas y Respuestas',
    'botTest.testResults.question': 'Pregunta',
    'botTest.testResults.questionLabel': 'P',
    'botTest.testResults.answerLabel': 'R',
    'botTest.testResults.answerStartTime': 'Tiempo de respuesta (primer token)',
    'botTest.testResults.no_results': 'No hay resultados de prueba disponibles',
    'botTest.testResults.no_results_description': 'Ejecute la prueba para ver los resultados aquí.',
};
